import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, AfterViewInit, DestroyRef, Inject, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { delay, startWith, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { normalizeLang, langToRoute } from '../../shared/localization/i18n.config';
import Typed from 'typed.js';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, TranslatePipe],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements AfterViewInit, OnDestroy {
  private typed: Typed | null = null;
  private destroyRef = inject(DestroyRef);

  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const keys = ['home.tagline1', 'home.tagline2', 'home.tagline3'];

    this.translate.onLangChange
      .pipe(
        startWith({ lang: this.translate.currentLang }),
        delay(150),
        switchMap(() => this.translate.get(keys)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((translations) => {
        this.destroyTyped();

        this.typed = new Typed('#typing-effect', {
          strings: keys.map((k) => translations[k]),
          typeSpeed: 40,
          backSpeed: 25,
          backDelay: 2500,
          startDelay: 500,
          loop: true,
          showCursor: true,
          cursorChar: '▌',
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyTyped();
  }

  private destroyTyped(): void {
    if (this.typed) {
      this.typed.destroy();
      this.typed = null;
    }

    const cursors = this.document.querySelectorAll('.typed-cursor');
    cursors.forEach((cursor) => cursor.remove());

    const el = this.document.querySelector('#typing-effect');
    if (el) el.textContent = '';
  }

  getResumeFilePath(): string {
    const baseName = 'vinicius-ribeiro';
    const extension = 'pdf';
    const currentLang = normalizeLang(this.translate.currentLang);
    return `resume/${baseName}-${currentLang}.${extension}`;
  }

  getBasePath(): string {
    return `/${langToRoute(normalizeLang(this.translate.currentLang))}`;
  }
}

